export default __webpack_public_path__ + "static/media/bg.c99d9e1b.svg";